import {create} from 'zustand';

export enum GeoState {
    init = "Init",
    granted = 'granted',
    denied = 'denied',
    prompt = 'prompt',
    unsupported = 'unsupported',
    unknown = 'unknown',
}

type UseGpsStore = {
    state: GeoState;
    showInstructions: boolean;
    isLoading: boolean

    // actions
    setShowInstructions: (value: boolean) => void;
    checkState: () => void;

    // internal: для очистки листенера
    _unsubPermissionsChange?: () => void;
};

// A successful position fix (check-in/out sets 'granted') outranks the Permissions API, which keeps
// reporting 'prompt' for one-time grants ("Allow this time", Firefox without "Remember", Safari) —
// only an explicit 'denied' downgrades it.
function mergeReported(current: GeoState, reported: GeoState): GeoState {
    return current === GeoState.granted && reported !== GeoState.denied ? current : reported;
}

async function safePermissionsQuery<T extends PermissionName>(
    name: T,
    timeoutMs = 800
): Promise<PermissionStatus | null> {
    if (!('permissions' in navigator)) return null;

    try {
        const q = (navigator as any).permissions.query({name});
        const timeout = new Promise<null>((resolve) => setTimeout(() => resolve(null), timeoutMs));
        const res = (await Promise.race([q, timeout])) as PermissionStatus | null;
        return res ?? null; // null -> не удалось быстро получить статус (оффлайн/баги Safari)
    } catch {
        return null;
    }
}

export const useGpsStore = create<UseGpsStore>((set, get) => ({
    state: GeoState.init,
    showInstructions: false,
    isLoading: false,

    setShowInstructions: (value) => set({showInstructions: value}),

    checkState: async () => {
        get()._unsubPermissionsChange?.();
        set({_unsubPermissionsChange: undefined, isLoading: true});
        if (!('geolocation' in navigator)) {
            console.log("'geolocation' not in navigator")
            set({state: GeoState.unsupported, isLoading: false});
            return;
        }
        const status = await safePermissionsQuery('geolocation', 1000);
        if (!status) {
            set((s) => ({state: mergeReported(s.state, GeoState.unknown), isLoading: false}));
            return;
        }

        const toEnum = GeoState[status.state as keyof typeof GeoState];
        set((s) => ({state: mergeReported(s.state, toEnum), isLoading: false}));
        const listener = () => {
            const next = GeoState[status.state as keyof typeof GeoState];
            set((s) => ({state: mergeReported(s.state, next)})); // isLoading тут не трогаем
        };

        status.addEventListener?.('change', listener);
        set({
            _unsubPermissionsChange: () => status.removeEventListener?.('change', listener),
        });

        //
        // if (!('permissions' in navigator)) {
        //     console.log("'permissions' not in navigator")
        //     set({state: GeoState.unknown, isLoading: false});
        //     return;
        // }
        //
        // if (!navigator.onLine && 'permissions' in navigator) {
        //     console.log("!navigator.onLine && 'permissions' in navigator")
        //     // оставим текущее состояние (или unknown), и попробуем обновиться позже
        //     set((s) => ({state: s.state ?? GeoState.unknown, isLoading: false}));
        //     return;
        // }
        //
        // try {
        //     console.log("Ask PermissionStatus")
        //     const status: PermissionStatus = await (navigator as any).permissions.query({
        //         name: 'geolocation' as PermissionName,
        //     });
        //
        //     console.log("Ask PermissionStatus status", status);
        //
        //     // status.state: 'granted' | 'denied' | 'prompt'
        //     set({state: GeoState[status.state as keyof typeof GeoState], isLoading: false});
        //
        //     const listener = () => {
        //         set({state: GeoState[status.state as keyof typeof GeoState], isLoading: false});
        //     };
        //
        //     status.addEventListener?.('change', listener);
        //     set({
        //         _unsubPermissionsChange: () =>
        //             status.removeEventListener?.('change', listener),
        //     });
        //     return status
        // } catch {
        //     set({state: GeoState.unknown, isLoading: false});
        // }
    },
}));
